import { SimpleListing } from '@th/shared/src/types/SimpleListing';

export default function isListingBlurred(
  listing: SimpleListing,
  isLoggedIn: boolean,
) {
  const listingMustBeBlurredWhenUnauthenticated =
    listing.isCommercialBuilding() || !listing.permissions.canDisplayPublic;

  return !isLoggedIn && listingMustBeBlurredWhenUnauthenticated;
}
